import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';

import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
    template: '<mat-checkbox [ngModel]="value" [disabled]="true"><span class="visually-hidden-focusable">{{params.text}}</span></mat-checkbox>',
    selector: 'bar-checkbox-cell-renderer',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatCheckboxModule, FormsModule]
})
/** @deprecated in favour of native agCheckboxCellRenderer. Checkbox cell renderer component. */
export class BarCheckboxCellRenderer implements ICellRendererAngularComp {
    protected value: boolean;
    protected params: any;

    agInit(params: any): void {
        this.params = params;
        this.value = this.params.value;
    }

    refresh(params: any): boolean {
        return false;
    }
}
